import { DateTime } from 'luxon';

function Footer() {
  return (
    <div className="flex justify-center items-center py-4 bg-neutral-900 text-white text-sm">
      © {DateTime.now().year} Athletes.org. All rights reserved.
    </div>
  );
}

export default Footer;
